import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border }) {
  return (
    <Wrapper
      className="animate pointer radius8"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#707070" : "#3a4d39")};
  background-color: ${(props) => (props.border ? "transparent" : "#4f6f52")};
  width: 100%;
  padding: 15px;
  outline: none;
  color: ${(props) => (props.border ? "#707070" : "#fff")};
  :hover {
    background-color: ${(props) => (props.border ? "#3a4d39" : "#3a4d39")};
    border: 1px solid #3a4d39;
    color: ${(props) => (props.border ? "#3a4d39" : "#fff")};
  }
`;

